// extracted by mini-css-extract-plugin
export var addButton = "_gu-0";
export var border = "_gu-8";
export var check = "_gu-h";
export var danger = "_gu-6";
export var dropdownContainer = "_gu-1";
export var editModalBody = "_gu-j";
export var footerContainer = "_gu-i";
export var fullWidth = "_gu-a";
export var hide = "_gu-9";
export var icon = "_gu-3";
export var input = "_gu-7";
export var inputFlex = "_gu-b";
export var inputWrapper = "_gu-c";
export var manualFocus = "_gu-5";
export var optionButton = "_gu-4";
export var pillWrapper = "_gu-e";
export var pointer = "_gu-2";
export var showOverflow = "_gu-f";
export var tagsFlex = "_gu-d";
export var xButton = "_gu-g";